import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import cn from 'classnames';
import { tabs } from '../constants/tabs';
import styles from '../Room.module.scss';

const TabContents = () => {
  const params = useParams();

  const activeIndex = useMemo(() => {
    const tab = tabs.find((item) => item.key === params.roomTab);

    return tab ? tab.index : 0;
  }, [params.roomTab]);

  return (
    <div style={{ overflow: 'hidden' }}>
      <div
        className={styles.tabsContentContainer}
        style={{ marginLeft: `-${activeIndex * 100}%` }}
      >
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={cn(styles.tabContent, {
              [styles.hidden]: params.roomTab !== tab.key,
            })}
          >
            {tab.renderContent()}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabContents;
